import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import HotArticles from './components/HotArticles';
import CommentSection from './components/CommentSection';
import StatsSection from './components/StatsSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <HotArticles />
        <CommentSection />
        <StatsSection />
      </main>
      <Footer />
    </>
  );
}